import { PropsWithChildren } from 'react';

import { Redirect } from 'react-router-dom';

export interface ProtectedRouteProps {
  isAccessGranted: boolean;
  redirectPath: string;
}

/**
 * A wrapper for routes to be protected
 *
 * Usage:
 * <Route element={<ProtectedRoute isAccessGranted={isAuthenticated} redirectPath={'/'} />}>
 *   <Route path="page" element={<Page />} />
 *   <Route path="dashboard" element={<Dashboard />} />
 * </Route>
 *
 * @param isAccessGranted
 * @param redirectPath
 * @param children
 * @constructor
 */
const ProtectedRoute: React.FC<PropsWithChildren<ProtectedRouteProps>> = ({
  isAccessGranted,
  redirectPath,
  children
}) => {
  if (!isAccessGranted) {
    return <Redirect to={redirectPath} />;
  }

  /**
   * We can use as a simple layout wrapper or using with multiple route descendant (as in the example above)
   */
  return <>{children}</>;
};

ProtectedRoute.displayName = 'ProtectedRoute';

export default ProtectedRoute;
